import React from "react";

const Title: React.FC<{ text: string; animate: boolean }> = ({text, animate}) => (
    <div className="text-3xl sm:text-3xl md:text-4xl text-center font-bold px-4 min-h-[3rem]">
        {text}
    </div>
);

export default Title;